import React, { useState, useEffect } from 'react';
import { X, Cookie, Shield, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Kullanıcının daha önce bir seçim yapıp yapmadığını kontrol et
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // 1 saniye gecikme ile banner'ı göster (UX için)
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    // Çerezleri kabul et
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    
    // Google Analytics'e bildir
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
    
    setIsVisible(false);
  };

  const handleReject = () => {
    // Çerezleri reddet
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    
    // Google Analytics'e bildir
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    
    setIsVisible(false);
  };

  const handleCustomize = () => {
    setShowDetails(!showDetails);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {/* Cookie Banner - Kompakt Versiyon */}
      <div className="fixed bottom-4 right-4 z-[9999] max-w-md animate-in slide-in-from-bottom-5 duration-500">
        <div className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#4A7C3A] to-[#8AC73E] px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Cookie className="w-5 h-5 text-white" />
                <h3 className="text-white font-bold text-sm">
                  🍪 Çerez Kullanımı
                </h3>
              </div>
              <button
                onClick={handleReject}
                className="text-white/80 hover:text-white transition-colors"
                aria-label="Kapat"
              >
                <X size={18} />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="p-4">
            <p className="text-gray-700 text-xs mb-3 leading-relaxed">
              Web sitemizde daha iyi deneyim için çerezler kullanıyoruz. 
              <a href="/gizlilik" className="text-[#8AC73E] hover:text-[#7AB62E] font-medium ml-1" target="_blank" rel="noopener noreferrer">
                Gizlilik Politikası
              </a>
            </p>

            {/* Detaylar (Opsiyonel) */}
            {showDetails && (
              <div className="bg-gray-50 rounded-lg p-3 mb-3 animate-in slide-in-from-top-2 duration-300">
                <div className="space-y-2">
                  {/* Zorunlu Çerezler */}
                  <div className="flex items-start space-x-2">
                    <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <h4 className="font-semibold text-xs text-gray-900">Zorunlu Çerezler</h4>
                      <p className="text-xs text-gray-600 mt-0.5">
                        Site işlevleri için gerekli.
                      </p>
                    </div>
                  </div>

                  {/* Analitik Çerezler */}
                  <div className="flex items-start space-x-2">
                    <Shield className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <h4 className="font-semibold text-xs text-gray-900">Analitik (Google Analytics)</h4>
                      <p className="text-xs text-gray-600 mt-0.5">
                        Site trafiği analizi. Anonim veri.
                      </p>
                    </div>
                  </div>

                  {/* KVKK */}
                  <div className="bg-blue-50 border border-blue-200 rounded p-2 mt-2">
                    <p className="text-xs text-blue-800">
                      <strong>KVKK Uyumu:</strong> Verileriniz 6698 sayılı kanun kapsamında korunur.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Buttons - Daha Kompakt */}
            <div className="flex flex-col gap-2">
              <Button
                onClick={handleAccept}
                className="w-full bg-[#8AC73E] hover:bg-[#7AB62E] text-white font-semibold py-2 text-sm"
              >
                <CheckCircle className="w-4 h-4 mr-1" />
                Kabul Et
              </Button>
              
              <div className="flex gap-2">
                <Button
                  onClick={handleCustomize}
                  variant="outline"
                  className="flex-1 border border-gray-300 hover:border-[#8AC73E] hover:bg-gray-50 text-xs py-2"
                >
                  {showDetails ? 'Gizle' : 'Detaylar'}
                </Button>
                
                <Button
                  onClick={handleReject}
                  variant="ghost"
                  className="flex-1 hover:bg-gray-100 text-xs py-2"
                >
                  Reddet
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
